// src/components/hub/work/filters/ActiveFilterChips.js
import React from "react";
import FilterChip from "./FilterChip";

// Active-filter chip row. Display names are resolved by the caller
// (getOwnerName for the owner, the allFilterOptions lookup for the client) so
// this stays a pure presentational component. The hasActiveFilters gate lives
// in the page — this renders the chips it's given.
const ActiveFilterChips = ({
  ownerName,
  clientName,
  service,
  pipeline,
  includeDone,
  search,
  onClearOwner,
  onClearClient,
  onClearService,
  onClearPipeline,
  onClearDone,
  onClearSearch,
}) => (
  <div className="flex items-center gap-2 flex-wrap mt-2">
    {ownerName && <FilterChip label="Owner" value={ownerName} onRemove={onClearOwner} />}
    {clientName && <FilterChip label="Client" value={clientName} onRemove={onClearClient} />}
    {service && <FilterChip label="Service" value={service} onRemove={onClearService} />}
    {pipeline && <FilterChip label="Pipeline" value={pipeline} onRemove={onClearPipeline} />}
    {includeDone && <FilterChip label="Include done" value="" onRemove={onClearDone} />}
    {search && <FilterChip label="Search" value={search} onRemove={onClearSearch} />}
  </div>
);

export default ActiveFilterChips;
